<template>
  <div class="theme-radio" :class="{ 'theme-radio_disabled': disabled }">
    <div v-if="checked" class="theme-radio__circle" />
  </div>
</template>

<script setup>
defineProps({
  checked: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
})
</script>

<style lang="scss" scoped>
$size: 12px;
$circle-size: 8px;

.theme-radio {
  border: 1px solid $brand-tertiary;
  border-radius: $size;
  width: $size;
  height: $size;
  display: flex;
  justify-content: center;
  align-items: center;
  &__circle {
    background-color: $brand-tertiary;
    border-radius: $circle-size;
    width: $circle-size;
    height: $circle-size;
  }
  &_gray,
  &_disabled {
    border-color: $gray-lighter;
    .theme-radio__circle {
      background-color: $gray-lighter;
    }
  }
}
</style>
